import React from 'react';
import { Lock, CreditCard, Sparkles, X } from 'lucide-react';

const PaywallModal = ({ isOpen, onClose, onUpgrade, feature = 'this feature', creditsNeeded = null }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" data-testid="paywall-modal">
      <div className="bg-slate-800 border border-slate-700 rounded-2xl p-8 max-w-md w-full shadow-2xl animate-fade-in">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg transition-colors"
          data-testid="paywall-close-btn"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-gradient-to-br from-amber-500/20 to-orange-500/20 rounded-full flex items-center justify-center border border-amber-500/30">
            <Lock className="w-8 h-8 text-amber-400" />
          </div>
        </div>

        {/* Content */}
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-white mb-3">
            Unlock {feature}
          </h2>
          <p className="text-slate-400">
            {creditsNeeded 
              ? `You need ${creditsNeeded} to use ${feature}. Upgrade your plan to continue creating amazing content.`
              : `To access ${feature}, you need an active plan. Choose a plan that fits your needs.`
            }
          </p>
        </div>

        {/* Benefits */}
        <div className="bg-slate-900/50 rounded-xl p-4 mb-6">
          <h4 className="text-sm font-bold text-slate-300 mb-3">What you&apos;ll get:</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-indigo-400" />
              AI-powered content calendars
            </li>
            <li className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-indigo-400" />
              Real-time news research
            </li>
            <li className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-indigo-400" />
              AI image generation
            </li>
            <li className="flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-indigo-400" />
              Multi-platform support
            </li>
          </ul>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={onUpgrade}
            data-testid="paywall-upgrade-btn"
            className="w-full py-3 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-black font-bold rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg shadow-amber-500/20"
          >
            <CreditCard className="w-5 h-5" />
            View Plans & Upgrade
          </button>
          <button
            onClick={onClose}
            data-testid="paywall-cancel-btn"
            className="w-full py-3 bg-slate-700 hover:bg-slate-600 text-slate-300 font-medium rounded-xl transition-colors"
          >
            Maybe Later
          </button>
        </div>

        {/* Note */}
        <p className="text-center text-xs text-slate-500 mt-4">
          Start with just $4.99 for a 7-day calendar
        </p>
      </div>
    </div>
  );
};

export default PaywallModal;
